{
    "first-name": "Amey",
    "last-name": "Rupji",
    "links": [
        {
            "text": "Summary",
            "href": "#summary-main",
            "active-id": "summary-main"
        },
        {
            "text": "Skills",
            "href": "#skills-main",
            "active-id": "skills-main"
        },
        {
            "text": "Timeline",
            "href": "#timeline-main",
            "active-id": "timeline-main"
        },
        {
            "text": "Resume",
            "href": "#resume-main",
            "active-id": "resume-main"
        },
        {
            "text": "Contact",
            "href": "#contact-main",
            "active-id": "contact-main"
        }
    ],
    "scroll-link": "#summary-main"
    
}